export const availableImageFormats = '.bmp,.gif,.jpg,.png,.jpeg,.heic,.heif';
export const availableAudioFormats = '.mp3,.aac,.wav';
export const availableVideoFormats = '.mp4,.m4v';
export const allAvailableFormats = `${availableImageFormats},${availableVideoFormats},${availableAudioFormats}`;
